export interface TabGeneralOptions {
    defaultTitle: string;
}

const defaultTabOptions: TabGeneralOptions = {
    defaultTitle: '',
};

export { defaultTabOptions };
